import { useMemo } from "react";
import { selectIsMobile, selectScreenOrientation, selectWindowSize, usePcpLiveLessonContext } from "../../store";
import { useIsMobile } from "../../utils";
import { useOrientation, useWindowSize } from "@uidotdev/usehooks";

export type ErrorIconSize = 'small' | 'medium';
export const SMALL_ICON_MAX_HEIGHT = 480;  //px

export const useErrorIconSize = (): ErrorIconSize => {
    const isMobile = useIsMobile();
    const orientation = useOrientation();
    const orientationString = useMemo(
        () => orientation.type.startsWith("landscape") ? "landscape" : "portrait",
        [orientation.type]
    );
    const windowHeight = useWindowSize().height;
    
    return useMemo(() =>
        isMobile && orientationString === 'landscape' && (
            windowHeight == null || windowHeight <= SMALL_ICON_MAX_HEIGHT
        ) ? 'small' : 'medium'
    , [isMobile, orientationString, windowHeight]);
}